import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
//Import Google Analytics
import VueAnalytics from "vue-analytics";

//import ApolloClient from "apollo-boost";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
//import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
//import { withClientState } from 'apollo-link-state';
import { ApolloLink, Observable } from "apollo-link";
import { createUploadLink } from "apollo-upload-client";
//import { setContext } from "apollo-link-context";
import VueApollo from "vue-apollo";
import FormAlert from "./components/shared/FormAlert";
import SocialSharing from "vue-social-sharing";
import VueHead from "vue-head";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";

//Register Global Component
Vue.component("form-alert", FormAlert);
Vue.component("inner-image-zoom", InnerImageZoom);

Vue.use(VueApollo);
// Setup ApolloClient
Vue.use(SocialSharing);
Vue.use(VueHead);
//and then use it in main.js
Vue.use(VueAnalytics, {
  id: "UA-173683506-1",
  router
});

const cache = new InMemoryCache({
  // cacheRedirects: {
  //   Query: {
  //     // movie: (_, { id }, { getCacheKey }) =>
  //     //   getCacheKey({ __typename: 'Movie', id });
  //   }
  // }
});

const request = async operation => {
  //const token = await AsyncStorage.getItem('token');
  // if no token with key of 'token' in localStorage, add it
  if (!localStorage.token) {
    localStorage.setItem("token", "");
  }
  if (!localStorage.graphqlError) {
    localStorage.setItem(
      "graphqlError",
      JSON.stringify({ message: "tmp", path: "tmp" })
    );
  } else if (localStorage.getItem("graphqlError")) {
    //var graphqlError = JSON.parse(localStorage.getItem("graphqlError"));
  }

  // console.dir(ApolloClient);
  // operation adds the token to an authorization header, with is sent to backend

  operation.setContext({
    headers: {
      authorization:
        "Bearer " +
        (localStorage.getItem("graphqlError") &&
        JSON.parse(localStorage.getItem("graphqlError")).message ==
          "Signature has expired"
          ? localStorage.getItem("refresh_token")
          : localStorage.getItem("token"))
    }
  });
};

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle;
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) handle.unsubscribe();
      };
    })
);

const uploadLink = createUploadLink({
  uri: "https://olympian.guru:5000/graphql"
});

const uploadOGLink = createUploadLink({
  uri: "https://marketplace.olympian.guru:5001/graphql"
});

export const defaultClient = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        //sendToLoggingService(graphQLErrors);
        for (let err of graphQLErrors) {
          // commit('setError',err);

          console.dir(err);
          //localStorage.setItem('graphqlError',err.path +':'+ err.message);
          localStorage.setItem("graphqlError", JSON.stringify(err));

          //store.dispatch("getNewToken");

          // localStorage.setItem('error',err);
        }
      }
      if (networkError) {
        //logoutUser();
      }
    }),
    requestLink,
    uploadLink
    // withClientState({
    //   defaults: {
    //     isConnected: true
    //   },
    //   resolvers: {
    //     Mutation: {
    //       updateNetworkStatus: (_, { isConnected }, { cache }) => {
    //         cache.writeData({ data: { isConnected }});
    //         return null;
    //       }
    //     }
    //   },
    //   cache
    // }),
    // No Need for HttpLink with createUpload link: https://stackoverflow.com/questions/49507035/how-to-use-apollo-link-http-with-apollo-upload-client
    // new HttpLink({
    //   link:  createUploadLink({ uri: "https://olympian.guru:5000/graphql"})
    //   //uri: 'https://olympian.guru:5000/graphql',
    //   credentials: 'same-origin'
    // })
  ]),
  cache
});

export const ogStoreClient = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        //sendToLoggingService(graphQLErrors);
        for (let err of graphQLErrors) {
          // commit('setError',err);

          console.dir(err);
          //localStorage.setItem('graphqlError',err.path +':'+ err.message);
          localStorage.setItem("graphqlError", JSON.stringify(err));

          //store.dispatch("getNewToken");

          // localStorage.setItem('error',err);
        }
      }
      if (networkError) {
        //logoutUser();
      }
    }),
    requestLink,
    uploadOGLink
  ]),
  cache
});

const urlMetaData = require("url-metadata");

const apolloProvider = new VueApollo({
  defaultClient
});
//var SocialSharing = require('vue-social-sharing');
Vue.config.productionTip = false;

new Vue({
  apolloProvider,
  router,
  store,
  urlMetaData,
  vuetify,
  render: h => h(App),
  created() {
    // execute getCurrentUser query
    if (localStorage.token) {
      this.$store.dispatch("getCurrentUser");

      if (localStorage.userId && localStorage.userId != "undefined") {
        this.$store.dispatch("getCurrentUserDetails", {
          userId: localStorage.getItem("userId")
        });
      }
    }
  }
}).$mount("#app");
